<template>
  <div class="equipment-form">
    <div class="title">装备信息</div>
    <div class="form">
      <van-form ref="equipmentForm" input-align="right" error-message-align="right">
        <van-cell-group>
          <!-- 服装尺码 -->
          <van-field
            v-model="formData.jerseySize"
            label="服装尺码"
            placeholder="请选择服装尺码"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择服装尺码' }]"
            @click="showJerseySizePicker = true"
          />
          
          <!-- 球鞋尺码 -->
          <van-field
            v-model="formData.shoeSize"
            label="球鞋尺码"
            placeholder="请选择球鞋尺码"
            readonly
            is-link
            :rules="[{ required: true, message: '请选择球鞋尺码' }]"
            @click="showShoeSizePicker = true"
          />
          
          <!-- 球衣号码 -->
          <van-field
            v-model="jerseyNumberDisplayText"
            label="球衣号码"
            placeholder="请选择球衣号码"
            readonly
            is-link
            :rules="[{ validator: validateJerseyNumbers, message: '请选择球衣号码' }]"
            @click="showJerseyNumberPicker = true"
          />
        </van-cell-group>
      </van-form>
    </div>

    <!-- 服装尺码选择器 -->
    <van-popup v-model="showJerseySizePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="jerseySizeOptions"
        @confirm="onJerseySizeConfirm"
        @cancel="showJerseySizePicker = false"
      />
    </van-popup>

    <!-- 球鞋尺码选择器 -->
    <van-popup v-model="showShoeSizePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="shoeSizeOptions"
        @confirm="onShoeSizeConfirm"
        @cancel="showShoeSizePicker = false"
      />
    </van-popup>

    <!-- 球衣号码选择器 -->
    <van-popup v-model="showJerseyNumberPicker" position="bottom">
      <div class="jersey-number-picker">
        <div class="picker-header">
          <span @click="showJerseyNumberPicker = false">取消</span>
          <span>选择球衣号码 (最多3个)</span>
          <span @click="onJerseyNumberConfirm">确定</span>
        </div>
        <div class="picker-content">
          <van-checkbox-group v-model="selectedJerseyNumbers">
            <van-cell-group>
              <van-cell
                v-for="number in jerseyNumberOptions"
                :key="number"
                :title="number.toString()"
                clickable
                @click="toggleJerseyNumber(number)"
              >
                <template #right-icon>
                  <van-checkbox :name="number" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Form, Field, Icon, Popup, Picker, CellGroup, Checkbox, Cell, Toast} from "vant";
Vue.use(Form).use(Field).use(Icon).use(Popup).use(Picker).use(CellGroup).use(Checkbox).use(Cell).use(Toast)

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        jerseySize: '',
        jerseyNumber: '',
        shoeSize: ''
      },
      // 选择器显示状态
      showJerseySizePicker: false,
      showShoeSizePicker: false,
      showJerseyNumberPicker: false,
      
      // 选项数据
      jerseySizeOptions: ['S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
      shoeSizeOptions: ['40', '41', '41.5', '42', '42.5', '43', '43.5', '44', '44.5', '45', '45.5', '46'],
      jerseyNumberOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      // 用于多选球衣号码的选中状态
      selectedJerseyNumbers: []
    };
  },
  watch: {
    form: {
      handler(newVal) {        
        if (newVal && Object.keys(newVal).length > 0) {
          // 避免循环更新，只在数据真正不同时才更新
          if (JSON.stringify(this.formData) !== JSON.stringify(newVal)) {
            this.formData = JSON.parse(JSON.stringify(newVal));
            // 处理球衣号码的多选状态
            if (newVal.jerseyNumber) {
              this.selectedJerseyNumbers = newVal.jerseyNumber.split(',').map(num => parseInt(num.trim()));
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
    // 移除formData的watch，避免循环
  },
  computed: {
    jerseyNumberDisplayText() {
      return this.selectedJerseyNumbers.join(', ');
    }
  },
  methods: {
    // 服装尺码确认
    onJerseySizeConfirm(value) {
      this.formData.jerseySize = value;
      this.showJerseySizePicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 球鞋尺码确认
    onShoeSizeConfirm(value) {
      this.formData.shoeSize = value;
      this.showShoeSizePicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 球衣号码确认
    onJerseyNumberConfirm() {
      this.formData.jerseyNumber = this.selectedJerseyNumbers.join(',');
      this.showJerseyNumberPicker = false;
      this.$emit('update:form', { ...this.formData });
    },
    
    // 切换球衣号码选中状态
    toggleJerseyNumber(number) {
      const index = this.selectedJerseyNumbers.indexOf(number);
      if (index > -1) {
        this.selectedJerseyNumbers.splice(index, 1);
      } else {
        // 最多选择3个号码
        if (this.selectedJerseyNumbers.length < 3) {
          this.selectedJerseyNumbers.push(number);
        } else {
          this.$toast('最多只能选择3个球衣号码');
        }
      }
    },
    
    // 验证表单
    validateForm() {
      return this.$refs.equipmentForm.validate()
    },
    
    // 验证球衣号码
    validateJerseyNumbers() {
      return this.selectedJerseyNumbers.length > 0;
    },
    
    // 重置表单
    resetForm() {
      this.formData = {
        jerseySize: '',
        jerseyNumber: '',
        shoeSize: ''
      };
      this.selectedJerseyNumbers = [];
    }
  }
};
</script>

<style scoped lang="scss">
.equipment-form{
  .title{
    background-color: #F5F5F5;
    font-size: 16px;
    font-weight: 600;
    color: #323233;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
  }
}

::v-deep .van-cell{
  min-height: 54px;
  box-sizing: border-box;
  align-items: center;
}

::v-deep .van-field__label{
  color: rgba(0, 0, 0, 0.9);
}

::v-deep .van-field__control{
  font-weight: 500;
}

// 球衣号码选择器样式
.jersey-number-picker {
  padding: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .picker-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-size: 16px;
    color: #323233;
  }

  .picker-content {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
